import { dataDesktopSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDesktopSolid = /*#__PURE__*/createIcon(dataDesktopSolid)
export default IconDesktopSolid
